module.exports = __webpack_public_path__ + "img/900-df6e20.png";